<template>
  <section>
    <!--汽运运输合同下载模板-->
    <div
      class="row"
      id="pdfDom"
      style="
        background-color: #fff;
        position: absolute;
        top: -1000px;
        z-index: -1;
      "
    >
      <div
        class="box"
        style="padding: 60px; font-size: 18px; line-height: 32px"
      >
        <h1
          style="
            text-align: center;
            margin-bottom: 10px;
            font-weight: bold;
            color: #000;
          "
        >
          货物运输服务合同
        </h1>
        <p style="text-align: right">
          合同签订地：武汉市青山区<span style="margin-left: 5px"
            >合同号：{{ data.contract_code }}</span
          >
        </p>
        <div class="nav">
          &nbsp;&nbsp;&nbsp;&nbsp;甲、乙双方本着平等公平、互惠互利的原则，在中华人民共和国法律、法规规定的范围内，在诚实守信、友好协商的基础上，现甲方委托乙方承运以下运输任务，特订立本合同，以便双方共同遵照执行。
          <table class="contract-table" border="1">
            <tr>
              <td width="14%">甲方</td>
              <td width="36%" colspan="6">{{ data.party_a }}</td>
              <td width="14%">统一社会信用代码</td>
              <td width="36%" colspan="6">{{ data.org_code }}</td>
            </tr>
            <tr>
              <td width="14%">乙方</td>
              <td width="22%" colspan="4">{{ data.party_b }}</td>
              <td width="14%">身份证号</td>
              <td width="22%" colspan="4">{{ data.id_text }}</td>
              <td width="14%">联系电话</td>
              <td width="22%" colspan="4">{{ data.phone_text }}</td>
            </tr>
            <tr>
              <td width="14%">承运车号/船号</td>
              <td width="36%" colspan="6">{{ data.vehicle_number }}</td>
              <td width="14%">起运时间</td>
              <td width="36%" colspan="6">{{ data.carriage_date }}</td>
            </tr>
            <tr>
              <td width="14%">货物名称</td>
              <td width="22%" colspan="4">{{ data.cargo_name }}</td>
              <td width="14%">重量（吨）</td>
              <td width="22%" colspan="4">{{ data.weight }}</td>
              <td width="14%">件数</td>
              <td width="22%" colspan="4">{{ data.quantity }}</td>
            </tr>
            <tr>
              <td width="14%">起运地</td>
              <td width="36%" colspan="6">{{ data.origin }}</td>
              <td width="14%">目的地</td>
              <td width="36%" colspan="6">{{ data.destination }}</td>
            </tr>
            <tr>
              <td width="14%">委托运输单位</td>
              <td width="36%" colspan="6">{{ data.client_name }}</td>
              <td width="14%">收货人 电话</td>
              <td width="36%" colspan="6">{{ data.receiver_phone }}</td>
            </tr>
          </table>
        </div>
        <div class="pr" style="padding: 0 15px">
          <div>
            <em class="title">一、甲方责任</em>
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;1.甲方负责发出运输指令，通知内容包含发运时间、运输方式、货物名称、数量、质量要求，并准确提供发运地方和目的地址及联络方式方法等信息，并负责装卸过程的协调处理，甲方须为托运货物投保。货物重量以货物签收凭证上确定的实际重量为准。
            </em>
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;2.甲方保证所托运的货物不属于国家违禁品，保证货物质量符合与收货方约定验收要求。因非运输途中产生货物质量不符合验收标准引起的无法卸货等经济损失由甲方承担。</em
            >
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;3.甲方负责货物质量等方面进行监督管理。</em
            >
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;4.甲方有权通过甲方物流平台对乙方车辆在途位置、货物跟踪等。</em
            >
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;5.甲方配合乙方妥善处理运输途中发生事故。</em
            >
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;6.甲方在货物交收及货物签收凭证签收后及时结算运费给乙方。</em
            >
          </div>
          <div>
            <em class="title">二、乙方责任</em>
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;1.乙方需提供真实有效、符合承运该批货物运输资质的承载工具和证件信息。</em
            >
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;2.乙方应严格按照甲方及甲方客户的要求，安全、准时、准确地将货物运至甲方指定的目的地。若因特殊情况，货物不能按预订时间到达时，乙方应及时与甲方取得联系，汇报情况并进行处理。</em
            >
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;3.<em class="title"
                >乙方在承运期间不可擅自开封拆箱、不以任何理由和形式扣押甲方货物</em
              >，否则箱内货物出现短少、质量问题、因扣货产生的经济损失均由乙方负责赔偿;如途中遇到路检路查货物需开箱检查，乙方必须向甲方递交国家公路机关出示的有效证明材料</em
            >
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;4.因乙方原因导致的货损、货差、交货不清等，相关损失（含甲方的经济损失）概由乙方负责。赔偿标准：产品报废者按货主产品出厂价格赔偿，部分损坏按实际维修费赔偿，但乙方能提供资料证明货物的损毁、灭失是因为不可抗力或货物本身的自然属性或货物合理的损耗以及托运人或收货人过错造成的，可不承担责任。</em
            >
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;5、乙方在履行合同过程中应注意安全，如发生任何人身伤亡事故或造成任何财产损失均由乙方自行承担一切法律后果，与甲方无关。如因乙方原因造成第三方人身或财产损失进而导致甲方受到第三方追索的，甲方有权向乙方追偿。</em
            >
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;6.运输途中交警扣车或发生交通事故，托运货物因延误所产生的一切费用及甲方的经济损失由乙方负责承担。</em
            >
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;7.乙方保证手机24小时开机，发生交通事故、货物损毁、灭失、道路堵塞等异常情况应随时报告。如手机关机或不报告情况，违约金按100元/次在运费中扣除。</em
            >
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;8.乙方需按甲方要求与收货方做好货物交接，规范使用并提供相关单据。货物送达收货地址或货物卸车后收货人拒绝在《货物签收凭证》（回单）上签收等情况应及时向甲方报告，直至《货物签收凭证》完整交给甲方后视为运输完成。</em
            >
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;9.乙方将货物安全送达收货地址后，其《货物签收凭证》（回单）必须在收货后七日之内，寄（送）至甲方，如延期，违约金按200元/天扣罚，邮寄《货物签收凭证》（回单）以邮戳日期为准。</em
            >
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;10.乙方在装卸现场应严格遵守甲方或甲方客户现场管理的有关规定。认真核对送货单货物型号、数量，如发现包装破损品装上车应及时向现场人员提出更换或要求出货仓出示货物破损的证明或在发货车单上签字注明。</em
            >
          </div>
          <div>
            <em class="title">三、附则</em>
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;1.本协议一式贰份，甲、乙双方各执壹份，自签字盖章之日起生效。</em
            >
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;2.《货物签收凭证》（回单）附本合同作为合同附件，与本合同具有同等法律效力。</em
            >
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;3.本合同执行过程中，如发生争议，由甲、乙双方共同协商解决，协商无果，可向合同签订地提起诉讼。</em
            >
          </div>
        </div>
        <div style="margin-top: 10px; margin-bottom: 10px">
          <div style="display: inline-block; margin-left: 5%">
            甲方签章：
            <p style="margin-top: 10px">签订时间：{{ data.contract_date }}</p>
          </div>
          <div style="display: inline-block; margin-left: 40%">
            乙方签字：
            <p style="margin-top: 10px">签订时间：{{ data.contract_date }}</p>
          </div>
        </div>
      </div>
    </div>
    <!--船运运输合同下载模板-->
    <div
      class="row"
      id="pdfDom1"
      style="
        background-color: #fff;
        position: absolute;
        top: -1000px;
        z-index: -1;
      "
    >
      <div
        class="box"
        style="padding: 60px; font-size: 18px; line-height: 32px"
      >
        <h1
          style="
            text-align: center;
            margin-bottom: 10px;
            font-weight: bold;
            color: #000;
          "
        >
          货物运输服务合同
        </h1>
        <p style="text-align: right">
          合同签订地：武汉市青山区<span style="margin-left: 5px"
            >合同号：{{ data.contract_code }}</span
          >
        </p>
        <div class="nav">
          &nbsp;&nbsp;&nbsp;&nbsp;甲、乙双方本着平等公平、互惠互利的原则，在中华人民共和国法律、法规规定的范围内，在诚实守信、友好协商的基础上，现甲方委托乙方承运以下运输任务，特订立本合同，以便双方共同遵照执行。
          <table class="contract-table" border="1">
            <tr>
              <td width="14%">甲方</td>
              <td width="86%" colspan="12">{{ data.party_a }}</td>
            </tr>
            <tr>
              <td width="14%">乙方</td>
              <td width="22%" colspan="4">{{ data.party_b }}</td>
              <td width="14%">身份证号</td>
              <td width="22%" colspan="4">{{ data.id_text }}</td>
              <td width="14%">联系电话</td>
              <td width="22%" colspan="4">{{ data.phone_text }}</td>
            </tr>
            <tr>
              <td width="14%">承运车号/船号</td>
              <td width="22%" colspan="4">{{ data.vehicle_number }}</td>
              <td width="14%">起运时间</td>
              <td width="22%" colspan="4">{{ data.carriage_date }}</td>
              <td width="14%">运输期限</td>
              <td width="22%" colspan="4"></td>
            </tr>
            <tr>
              <td width="14%">货物名称</td>
              <td width="22%" colspan="4">{{ data.cargo_name }}</td>
              <td width="14%">重量（吨）</td>
              <td width="22%" colspan="4">{{ data.weight }}</td>
              <td width="14%">件数</td>
              <td width="22%" colspan="4">{{ data.quantity }}</td>
            </tr>
            <tr>
              <td width="14%">起运地</td>
              <td width="36%" colspan="6">{{ data.origin }}</td>
              <td width="14%">目的地</td>
              <td width="36%" colspan="6">{{ data.destination }}</td>
            </tr>
            <tr>
              <td width="14%">委托运输单位</td>
              <td width="36%" colspan="6">{{ data.client_name }}</td>
              <td width="14%">收货人 电话</td>
              <td width="36%" colspan="6">{{ data.receiver_phone }}</td>
            </tr>
          </table>
        </div>
        <div class="pr" style="padding: 0 15px">
          <div>
            <em class="title">一、甲方责任</em>
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;1..甲方负责发出运输指令，通知内容包含发运时间、运输方式、货物名称、数量、质量要求，并准确提供发运地方和目的地址及联络方式方法等信息，并负责装卸过程的协调处理，甲方须为托运货物投保。货物重量以货物签收凭证上确定的实际重量为准。</em
            >
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;2.甲方保证所托运的货物不属于国家违禁品，保证货物质量符合与收货方约定验收要求。因非运输途中产生货物质量不符合验收标准引起的无法卸货等经济损失由甲方承担。</em
            >
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;3.甲方负责货物质量等方面进行监督管理。</em
            >
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;4.甲方有权通过甲方物流平台对乙方车辆在途位置、货物跟踪等。</em
            >
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;5.甲方配合乙方妥善处理运输途中发生事故。</em
            >
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;6.甲方在货物交收及货物签收凭证签收后及时结算运费给乙方。</em
            >
          </div>
          <div>
            <em class="title">二、乙方责任</em>
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;1.乙方需提供真实有效、符合承运该批货物运输资质的承载工具和证件信息。</em
            >
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;2.乙方应严格按照甲方及甲方客户的要求，安全、准时、准确地将货物运至甲方指定的目的地。若因特殊情况，货物不能按预订时间到达时，乙方应及时与甲方取得联系，汇报情况并进行处理。</em
            >
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;3.<em class="title"
                >乙方在承运期间不可擅自开封拆箱、不以任何理由和形式扣押甲方货物</em
              >，否则，箱内货物出现短少、质量问题、因扣货产生的经济损失均由乙方负责赔偿；如途中遇到相关主管部门需将货物开箱检查，乙方必须向甲方递交国家相关主管机关出示的有效证明材料。</em
            >
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;4.因乙方原因导致的货损、货差、交货不清等，相关损失（含甲方的经济损失）概由乙方负责。赔偿标准：产品报废者按货主产品出厂价格赔偿，部分损坏按实际维修费赔偿，但乙方能提供资料证明货物的损毁、灭失是因为不可抗力或货物本身的自然属性或货物合理的损耗以及托运人或收货人过错造成的，可不承担责任。</em
            >
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;5、乙方在履行合同过程中应注意安全，如发生任何人身伤亡事故或造成任何财产损失均由乙方自行承担一切法律后果，与甲方无关。如因乙方原因造成第三方人身或财产损失进而导致甲方受到第三方追索的，甲方有权向乙方追偿。</em
            >
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;6.运输途中政府相关主管部门扣车、扣船或发生事故，托运货物因延误所产生的一切费用及甲方的经济损失由乙方负责承担。</em
            >
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;7.乙方保证手机 24
              小时开机，发生任何事故、货物损毁、灭失、道路堵塞、台风、洪水等异常情况应随时报告。如手机关机或不报告情况，违约金按
              100 元/次在运费中扣除。</em
            >
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;8.乙方需按甲方要求与收货方做好货物交接，规范使用并提供相关单据。货物送达收货地址或货物卸车（卸船）后收货人拒绝在《货物签收凭证》（回单）上签收等情况应及时向甲方报告，直至《货物签收凭证》完整交给甲方后视为运输完成。</em
            >
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;9.乙方将货物安全送达收货地址后，其《货物签收凭证》（回单）必须在收货后七日之内，寄（送）至甲方，如延期，违约金按200
              元/天扣罚，邮寄《货物签收凭证》（回单）以邮戳日期为准。</em
            >
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;10.乙方在装卸现场应严格遵守甲方或甲方客户现场管理的有关规定。认真核对送货单货物型号、数量，如发现包装破损品装上车（船舶）应及时向现场人员提出更换或要求出货仓出示货物破损的证明或在发货单上签字注明。</em
            >
          </div>
          <div>
            <em class="title">三、附则</em>
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;1.本协议一式贰份，甲、乙双方各执壹份，自签字盖章之日起生效。</em
            >
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;2.《货物签收凭证》（回单）附本合同作为合同附件，与本合同具有同等法律效力。</em
            >
            <br />
            <em
              >&nbsp;&nbsp;&nbsp;&nbsp;3.本合同执行过程中，如发生争议，由甲、乙双方共同协商解决，协商无果，可向合同签订地提起诉讼。</em
            >
          </div>
        </div>
        <div style="margin-top: 20px; margin-bottom: 20px">
          <div style="display: inline-block; margin-left: 5%">
            甲方签章：
            <p style="margin-top: 20px">签订时间：{{ data.contract_date }}</p>
          </div>
          <div style="display: inline-block; margin-left: 40%">
            乙方签字：
            <p style="margin-top: 20px">签订时间：{{ data.contract_date }}</p>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="上传运输合同"
      :visible.sync="isShow"
      class="dialog-sm"
      v-dialogDrag
    >
      <!-- <el-button type="text" style="position: absolute;top: 20%;left: 40%;" @click="downLoad">下载协议模板<i class="el-icon-download el-icon--right"></i></el-button> -->
      <el-form
        class="col-2 clearfix"
        :inline="true"
        label-width="70px"
        style="padding-left: 40px"
        :model="receiptData"
        label-position="left"
      >
        <el-row>
          <el-form-item style="width: 33%; margin-right: 0%">
            <el-row>运输合同</el-row>
            <el-row class="photo">
              <el-row
                class="file"
                style="margin-bottom: 10px !important; height: 160px"
              >
                <el-row class="file-bd">
                  <el-upload
                    drag
                    class="upload"
                    action="#"
                    accept=".jpg,.jpeg,.png,.bmp,,.JPG,.JPEG,.PDF"
                    :show-file-list="false"
                    :http-request="fnUploadRequestAgreement"
                  >
                    <!-- <img v-if="image.image_url" :src="image.image_url"> -->
                    <div v-if="receiptData.agreement_url">
                      <img
                        :src="receiptData.agreement_url"
                        alt=""
                        v-if="!receiptData.agreement_url.includes('.pdf')"
                      />
                      <pdf
                        :src="receiptData.agreement_url"
                        v-if="receiptData.agreement_url.includes('.pdf')"
                      ></pdf>
                    </div>
                    <!-- <div >
                        <pdf :src="receiptData.agreement_url" v-if="receiptData.agreement_url.includes('.pdf')"></pdf>
                      </div> -->
                    <i v-else class="iconfont icon-icon81"></i>
                  </el-upload>
                </el-row>
                <el-row>
                  <a
                    target="_blank"
                    :href="receiptData.agreement_url"
                    v-if="
                      receiptData.agreement_url &&
                      receiptData.agreement_url.includes('.pdf')
                    "
                    class="file-fr-label preview"
                    >查看原件</a
                  >
                  <el-button
                    type="text"
                    class="yu-btn"
                    v-if="
                      receiptData.agreement_url &&
                      !receiptData.agreement_url.includes('.pdf')
                    "
                  >
                    预览
                    <viewer>
                      <img
                        :src="receiptData.agreement_url"
                        alt=""
                        class="yulan"
                      />
                    </viewer>
                  </el-button>
                  <!-- <el-button type="text" class="mainColor del-btn" @click="delUrl">删除</el-button> -->
                  <span @click="downLoad" class="mainColor hand fr"
                    ><i class="el-icon-download el-icon--right"></i
                    >下载合同模板</span
                  >
                </el-row>
              </el-row>
            </el-row>
          </el-form-item>
        </el-row>
      </el-form>
      <el-row class="btn-group sm">
        <el-button
          type="primary"
          @click="receiptMethods"
          :loading="loading"
          :disabled="receiptData.agreement_url == ''"
          >保 存</el-button
        >
        <el-button type="info" @click="isShow = false">取 消</el-button>
      </el-row>
    </el-dialog>
  </section>
</template>
<script>
import { regionDataPlus, CodeToText } from "@/assets/js/app";
import moment from "moment";
import { isSuccess } from "@/assets/js/utils";
import pdf from "vue-pdf";
export default {
  components: {
    pdf,
  },
  data() {
    return {
      isShow: false,
      loading: false,
      showAgreement: false,
      data: {},
      receiptData: {
        agreement_url: "",
      },
      pid: "",
      waybill_pid: "",
      ship_car_type: "",
    };
  },
  created() {},
  methods: {
    downLoad() {
      api("contract.single.agreement.info", { pid: this.waybill_pid }).then(
        (res) => {
          let data;
          if ((data = isSuccess(res))) {
            this.data = data;
            this.$nextTick(()=>{
              if (this.ship_car_type == "CAR_TYPE") {
                this.getPdf();
              }
              if (this.ship_car_type == "BOAT_TYPE") {
                this.getPdf("#pdfDom1");
              }
            })
          } else {
            alert(res.msg);
          }
        }
      );
    },
    guid() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },
    show(row) {
      this.pid = row.pid;
      this.waybill_pid = row.waybill_pid;
      this.isShow = true;
      this.receiptData.agreement_url = "";
      this.ship_car_type = row.ship_car_type;
      api("waybill.agreement.query", { id: this.pid }).then((res) => {
        let data;
        if ((data = isSuccess(res))) {
          this.receiptData = data;
        } else {
          alert(res.msg);
          this.isShow = false;
        }
      });
      console.log(this.receiptData.agreement_url);
      console.log(this.receiptData.agreement_url == "");
    },
    //上传回单图片
    async fnUploadRequestAgreement(option) {
      // this.imgNum++;
      // this.progressLength = 0
      // this.showProgress = true
      // const interval = setInterval(() => {
      //   if (this.progressLength >= 99) {
      //     clearInterval(interval)
      //     return
      //   }
      //   this.progressLength += 1
      // }, 20)
      api("aliyun.sts.verify").then((res) => {
        let data;
        if ((data = isSuccess(res))) {
          let OSS = require("ali-oss");
          let store = new OSS({
            region: data.aliyun_region,
            accessKeyId: data.access_key_id,
            accessKeySecret: data.access_key_secret,
            stsToken: data.security_token,
            bucket: data.aliyun_bucket,
          });
          let random_name =
            this.guid() + "." + option.file.name.split(".").pop();
          store.put(random_name, option.file).then((res) => {
            this.receiptData.agreement_url = res.url;
          });
        }
      });
    },
    // 确认
    receiptMethods() {
      this.receiptData.waybill_id = this.pid;
      this.loading = true;
      api("waybill.agreement.create", this.receiptData).then((res) => {
        let data;
        alert(res.msg);
        this.loading = false;
        if ((data = isSuccess(res))) {
          this.isShow = false;
          this.$emit("upup");
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import "src/assets/sass/mixin";
.contract-table {
  border: 1px solid black;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  border-collapse: collapse;
}
.bold {
  font-weight: bold;
}
.title {
  font-size: 18px;
  font-weight: bolder;
}
.yu-btn {
  font-size: 14px;
  // color: #cc0816;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/details/agreement-model.vue